module.exports = "<div class=\"message-container\">\n  <div class=\"message\">\n    You will need to sign in to continue.\n  </div>\n\n  <div class=\"actions\">\n    <a mat-button [href]=\"signInUrl\">\n      SIGN IN\n    </a>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/auth/auth.component.html
// module id = ./src/app/auth/auth.component.html
// module chunks = main